<h1 mat-dialog-title>Wareneingang / Warenausgang anlegen</h1>
<mat-dialog-content>
    <div class="flex gap-4 my-4">
        <button app-button mat-dialog-close="in"><fa-icon icon="plus"></fa-icon> Wareneingang</button>
        <button app-button mat-dialog-close="out"><fa-icon icon="minus"></fa-icon> Warenausgang</button>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button app-button Inverted Color="cancel" mat-dialog-close="">abbrechen</button>
</mat-dialog-actions>
